import { render } from "./tipofolio.vue?vue&type=template&id=a24f97b0"
import script from "./tipofolio.vue?vue&type=script&lang=js"
export * from "./tipofolio.vue?vue&type=script&lang=js"

import "./tipofolio.vue?vue&type=style&index=0&id=a24f97b0&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__